import React from 'react';
import { Router, HashRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import {
  Provider as StoreProvider,
  useDispatch,
  useSelector,
} from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';

import { setIsSubApp } from '~/actions/global';
import {
  OmniApplicationInitialLocationWatcher,
  useAppContext,
} from '~/application-context';

import AuthProvider from './providers/auth';
import { history } from './providers/auth/helpers';
import { SnackbarProvider } from './providers/snackbar';
import { theme } from './providers/theme';
import GlobalsProvider from './providers/globals';
import { TutorialProvider } from './providers/tutorial';
import { configureStore } from './store';

import routes from './routes';

import ErrorBoundary from './components/ErrorBoundary';
import ScrollReset from './components/ScrollReset';
import StylesProvider from './components/CustomStylesProvider';

import 'react-perfect-scrollbar/dist/css/styles.css';
import './mixins/moment';
import './mixins/validate';
import './assets/scss/main.scss';
import { getIsSubApp } from '~/selectors';
import { LocalStorage } from '~/helpers';

const store = configureStore();

function OmniApplicationRoot() {
  return (
    <StoreProvider store={store}>
      <OmniApplicationContent />
    </StoreProvider>
  );
}

function OmniApplicationContent() {
  const direction = 'ltr';

  const appContext = useAppContext();
  const dispatch = useDispatch();
  const isSubApp = useSelector(getIsSubApp);

  React.useEffect(() => {
    const _isSubApp = !appContext.isStandalone;

    LocalStorage.setIsSubApp(_isSubApp);
    dispatch(setIsSubApp(_isSubApp));
  }, [dispatch, appContext.isStandalone]);

  const RouterComponent = appContext.isStandalone ? Router : HashRouter;

  // Prevent to load all component tree in the not updated state
  if (!isSubApp === !appContext.isStandalone) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider direction={direction}>
        <ErrorBoundary>
          <SnackbarProvider>
            <RouterComponent history={history}>
              <AuthProvider>
                <GlobalsProvider>
                  <TutorialProvider>
                    <ScrollReset />
                    {/* <GoogleAnalytics/> */}
                    {renderRoutes(routes)}
                  </TutorialProvider>
                </GlobalsProvider>
              </AuthProvider>
              <OmniApplicationInitialLocationWatcher />
            </RouterComponent>
          </SnackbarProvider>
        </ErrorBoundary>
      </StylesProvider>
    </ThemeProvider>
  );
}

export default OmniApplicationRoot;
